import { Category } from './store'

export const fetchGetCategories = (): Promise<Category[]> =>
  fetch(`/api/v1/categories`).then((res) => res.json())
